module.exports = __webpack_public_path__ + "4c5c41732f44f235b1235300ee5a8cc2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/humanitix.svg
// module id = 6xpY
// module chunks = 5